// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';
import { NewPlant, type Plant, type PlantWireFormat } from '../Plant/Plant';

export class TruckingType {
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  readonly plants: Plant[];
  readonly categories: Enums.ProductCategory[];
  readonly rateUnit: Enums.Unit | null;
  readonly defaultHaulRate: Currency | null;
  readonly defaultHaulCost: Currency | null;
  readonly minimumHaulCharge: number | null;
  readonly loadCapacity: string | null;
  readonly loadCapacityUnit: Enums.Unit | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.description = data.description === undefined ? null : data.description;
    this.plants = (data.plants ?? []).map((plants: any) => NewPlant(plants));
    this.categories = (data.categories ?? []).map((categories: any) =>
      categories === undefined ? Enums.ProductCategory.ReadyMix : categories,
    );
    this.rateUnit = data.rateUnit === undefined ? Enums.Unit.Tn : data.rateUnit;
    this.defaultHaulRate =
      (data.defaultHaulRate ?? null) === null ? null : NewCurrency(data.defaultHaulRate);
    this.defaultHaulCost =
      (data.defaultHaulCost ?? null) === null ? null : NewCurrency(data.defaultHaulCost);
    this.minimumHaulCharge = data.minimumHaulCharge === undefined ? null : data.minimumHaulCharge;
    this.loadCapacity = data.loadCapacity === undefined ? null : data.loadCapacity;
    this.loadCapacityUnit =
      data.loadCapacityUnit === undefined ? Enums.Unit.Tn : data.loadCapacityUnit;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): TruckingType {
    const zeroValues: ExcludeMethodsDeep<TruckingType> = {
      id: NIL_UUID,
      name: '',
      description: null,
      plants: [],
      categories: [],
      rateUnit: Enums.Unit.Tn,
      defaultHaulRate: null,
      defaultHaulCost: null,
      minimumHaulCharge: null,
      loadCapacity: null,
      loadCapacityUnit: Enums.Unit.Tn,
      isArchived: false,
    };
    return new TruckingType(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TruckingTypeWireFormat = {
  id: string;
  name: string;
  description: string | null;
  plants: PlantWireFormat[];
  categories: string[];
  rateUnit: string | null;
  defaultHaulRate: CurrencyWireFormat | null;
  defaultHaulCost: CurrencyWireFormat | null;
  minimumHaulCharge: number | null;
  loadCapacity: string | null;
  loadCapacityUnit: string | null;
  isArchived: boolean;
};

type NewTruckingTypeProps = PartialDeep<TruckingType, { recurseIntoArrays: true }>;
export const NewTruckingType: (props: NewTruckingTypeProps) => TruckingType = (props) =>
  new TruckingType(props);

type NewTruckingTypeFromWireFormatProps = PartialDeep<
  TruckingTypeWireFormat,
  { recurseIntoArrays: true }
>;
export const NewTruckingTypeFromWireFormat: (
  props: NewTruckingTypeFromWireFormatProps,
) => TruckingType = (props) => new TruckingType(props);
